import { useI18n } from '@hive/i18n';

import { Button } from '../../ui/button';
import { AuthPageContainer } from '../auth-components';

export const ExpiredPage = ({ onOpenHive }: { onOpenHive: () => void }) => {
  const t = useI18n();
  return (
    <AuthPageContainer
      title={t['com.hive.expired.page.title']()}
      subtitle={t['com.hive.expired.page.new-subtitle']()}
    >
      <Button variant="primary" size="large" onClick={onOpenHive}>
        {t['com.hive.auth.open.hive']()}
      </Button>
    </AuthPageContainer>
  );
};
